import { render, staticRenderFns } from "./ProductRankings.vue?vue&type=template&id=4d939e02&scoped=true"
import script from "./ProductRankings.vue?vue&type=script&lang=js"
export * from "./ProductRankings.vue?vue&type=script&lang=js"
import style0 from "./ProductRankings.vue?vue&type=style&index=0&id=4d939e02&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d939e02",
  null
  
)

export default component.exports